import { apiInstance } from "../utils";

export const deleteAllSavedSearch = async () => {
  const response = await apiInstance.delete("/pesquisas-salvas");
  return response.data;
};
